import React from 'react';

export const PaymentMethodsSection: React.FC = () => {
  return (
    <section className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <h2 className="text-4xl lg:text-5xl font-bold text-gray-900 mb-4">
            Пополнение и вывод средств
          </h2>
          <p className="text-xl text-gray-600">
            Все доступные способы для игроков из России
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
          <div className="bg-gradient-to-br from-orange-400 to-pink-500 rounded-3xl p-8 text-white relative overflow-hidden">
            <div className="absolute top-6 right-6 w-12 h-12 bg-white/20 rounded-full flex items-center justify-center cursor-pointer hover:bg-white/30 transition-colors">
              <i className="ri-arrow-right-up-line text-2xl"></i>
            </div>

            <h3 className="text-3xl font-bold mb-6">Пополнение с карт российских банков</h3>

            <div className="grid grid-cols-2 gap-4 mb-6">
              <div className="bg-white/10 backdrop-blur-sm rounded-xl p-4 flex items-center gap-3">
                <div className="w-12 h-12 bg-white rounded-lg flex items-center justify-center">
                  <i className="ri-bank-card-fill text-2xl text-green-600"></i>
                </div>
                <span className="font-medium">Сбербанк</span>
              </div>
              <div className="bg-white/10 backdrop-blur-sm rounded-xl p-4 flex items-center gap-3">
                <div className="w-12 h-12 bg-white rounded-lg flex items-center justify-center">
                  <i className="ri-bank-card-fill text-2xl text-yellow-600"></i>
                </div>
                <span className="font-medium">Тинькофф</span>
              </div>
              <div className="bg-white/10 backdrop-blur-sm rounded-xl p-4 flex items-center gap-3">
                <div className="w-12 h-12 bg-white rounded-lg flex items-center justify-center">
                  <i className="ri-bank-card-fill text-2xl text-red-600"></i>
                </div>
                <span className="font-medium">Альфа-Банк</span>
              </div>
              <div className="bg-white/10 backdrop-blur-sm rounded-xl p-4 flex items-center gap-3">
                <div className="w-12 h-12 bg-white rounded-lg flex items-center justify-center">
                  <i className="ri-bank-card-fill text-2xl text-blue-600"></i>
                </div>
                <span className="font-medium">ВТБ</span>
              </div>
            </div>

            <p className="text-lg font-medium">Мгновенное зачисление</p>
          </div>

          <div className="bg-gradient-to-br from-purple-400 to-indigo-500 rounded-3xl p-8 text-white relative overflow-hidden">
            <div className="absolute top-6 right-6 w-12 h-12 bg-white/20 rounded-full flex items-center justify-center cursor-pointer hover:bg-white/30 transition-colors">
              <i className="ri-arrow-right-up-line text-2xl"></i>
            </div>

            <h3 className="text-3xl font-bold mb-6">Альтернативные способы ввода</h3>

            <div className="grid grid-cols-2 gap-4 mb-6">
              <div className="bg-white/10 backdrop-blur-sm rounded-xl p-4 flex items-center gap-3">
                <div className="w-12 h-12 bg-white rounded-lg flex items-center justify-center">
                  <i className="ri-exchange-funds-fill text-2xl text-purple-600"></i>
                </div>
                <span className="font-medium">СБП</span>
              </div>
              <div className="bg-white/10 backdrop-blur-sm rounded-xl p-4 flex items-center gap-3">
                <div className="w-12 h-12 bg-white rounded-lg flex items-center justify-center">
                  <i className="ri-wallet-3-fill text-2xl text-yellow-600"></i>
                </div>
                <span className="font-medium">ЮMoney</span>
              </div>
              <div className="bg-white/10 backdrop-blur-sm rounded-xl p-4 flex items-center gap-3">
                <div className="w-12 h-12 bg-white rounded-lg flex items-center justify-center">
                  <i className="ri-wallet-2-fill text-2xl text-orange-600"></i>
                </div>
                <span className="font-medium">Qiwi</span>
              </div>
              <div className="bg-white/10 backdrop-blur-sm rounded-xl p-4 flex items-center gap-3">
                <div className="w-12 h-12 bg-white rounded-lg flex items-center justify-center">
                  <i className="ri-bit-coin-fill text-2xl text-orange-500"></i>
                </div>
                <span className="font-medium">Криптовалюты</span>
              </div>
            </div>

            <p className="text-lg font-medium">Анонимность и безопасность</p>
          </div>
        </div>
      </div>
    </section>
  );
};